// import external dependencies
import 'jquery';
import 'wowjs';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

function checkUrl() { 
  var url = window.location.href;
  var split = url.split('#');
  $('.navigation a').removeClass('active-navitem');
  $('.id'+split[1]).addClass('active-navitem');
  
}

checkUrl();
var url = window.location.href;
var split = url.split('#');
if(split[1]!=1 && Number.isInteger(split[1])){
  window.location = window.location.href.replace('#1','#'+split[1]);
}

window.addEventListener('hashchange', checkUrl);

function initOwl() {
  var owl = $('.owl-carousel').owlCarousel({
    loop:false,
    margin:5,
    lazyLoad: true,
    URLhashListener:true,
    startPosition: 'URLHash',
    responsiveClass:true,
    navText: ['<i class=\'fas fa-chevron-left chevron\'></i> <span class=\'nl\'>Vorige</span> <span class=\'eng\'>Previous</span>','<span class=\'nl\'>Volgende</span> <span class=\'eng\'>Next</span> <i class=\'fas fa-chevron-right chevron\'></i>'],
    responsive:{
      0:{
        items:1,
        nav:true,
      },
      600:{
        items:1,
        nav:false,
      },
      1000:{
        items:1,
        nav:true,
        loop:false,
      },
    },
  });


  owl.on('changed.owl.carousel', function(event) {

    if(event.item.count == (event.item.index+1)){
      $('.owl-prev').css('zIndex', '-60');
      $('.owl-prev').css('opacity', '0');
    }
    else{
      $('.owl-prev').css('zIndex', '999');
      $('.owl-prev').css('opacity', '1');
    }
  })

}

$(document.documentElement).keyup(function(event) {
  if (event.keyCode == 37) {
    $('.owl-prev').click();
  } else if (event.keyCode == 39) {
    $('.owl-next').click();
  }
});


$('.category-wrapper').owlCarousel({
  items : 4,
  loop  : true,
  margin : 30,
  nav    : true,
  smartSpeed :900,
  lazyLoad: true,
  navText : ['<i class="fas fa-chevron-left"></i>','<i class="fas fa-chevron-right"></i>'],
});

function goToTop() { // eslint-disable-line no-unused-vars
  $('html, body').animate({ scrollTop: '0px' });
}

function goToBottom() { // eslint-disable-line no-unused-vars
  var height = jQuery('.content').height();
  $('html, body').animate({ scrollTop: height+'px' });
}

function checkWidthOwl() {
  var owl = $('.owl-carousel');
  if ($(window).width() < 900) {
    if (owl.on('initialized.owl.carousel')) {
      owl.trigger('destroy.owl.carousel');
      owl.addClass('owl-mobile');

      $('.id1').on('click', goToTop);
      $('.idcontact').on('click', goToBottom);

      $( 'img.slide' ).each(function() {
        $(this).attr('src', $(this).attr('data-src-mobile'));
      });

    }
  } else {
    initOwl();
    goToTop();
    owl.removeClass('owl-mobile');
      document.ontouchmove = function(event){
        if($(window).width() >  $(window).height()){
        event.preventDefault();
      }
    }

    $('.id1').off('click', goToTop);
    $('.idcontact').off('click', goToBottom);
  }
}

$('.disable-owl-swipe').on('touchstart mousedown', function(e) {
     // Prevent carousel swipe
     e.stopPropagation();
   })

checkWidthOwl();
window.addEventListener('resize', checkWidthOwl);



// WEBPACK FOOTER //
// ./scripts/main.js